import { emptySplitApi } from "../api/apiSlice";

export const loginApi = emptySplitApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // getAppUser: builder.query<AppUserState | Error, string | void>({
    //     invalidatesTags: ["AppUser"]
    // }),
    login: builder.mutation({
      query: (data: any) => ({
        url: "/account/login",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),

      invalidatesTags: ["AppUser"],
      // providesTags: (result, error, arg) => {
      //     if (result?.token) {
      //         return ["AppUser", result]
      //     } else {
      //         return ["AppUser"]
      //     }
      // }
    }),
    logout: builder.mutation({
      query: (data: any) => ({
        url: "/account/logout",
        method: "POST",
        body: {},
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
      invalidatesTags: [],
    }),
    register: builder.mutation({
      query: (data: any) => ({
        url: "/clients/",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),

      // invalidatesTags: ["Client"],
      // providesTags: (result, error, arg) => {
      //     if (result?.token) {
      //         return ["AppUser", result]
      //     } else {
      //         return ["AppUser"]
      //     }
      // }
    }),
    editClient: builder.mutation({
      query: (data: any) => ({
        url: "/clients",
        method: "PATCH",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
    validateUser: builder.mutation({
      query: (data: any) => ({
        url: "/account/forgot-password/validate-user",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
    verifyOTP: builder.mutation({
      query: (data: any) => ({
        url: "/account/forgot-password/verify-otp",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
    updatePassword: builder.mutation({
      query: (data: any) => ({
        url: "/account/forgot-password/update",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
    resendClientOTP: builder.mutation({
      query: (data: any) => ({
        url: "/clients/resend-otp",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
    verifyClient: builder.mutation({
      query: (data: any) => ({
        url: "/clients/verify",
        method: "POST",
        body: data,
        validateStatus: (response: any, result: any) => {
          if (result?.invalidData || result?.error) {
            return true;
          }
          return response.ok;
        },
      }),
    }),
  }),
});

export const {
  // useGetAppUserQuery,
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useEditClientMutation,
  useValidateUserMutation,
  useVerifyOTPMutation,
  useUpdatePasswordMutation,
  useResendClientOTPMutation,
  useVerifyClientMutation,
} = loginApi;
